import { ActionTemplate } from '../../typings';

interface RequestActions extends Array<string> {
  [0]: string;
  [1]: string;
  [2]: string;
}

const apiActions = ['LOADING', 'SUCCESS', 'ERROR'];

export default function requestActionsFactory(actionTemplate: ActionTemplate): RequestActions {
  const actions = apiActions.map((action: string): string => actionTemplate(action)) as unknown;
  return actions as RequestActions;
}
